export const FLAGS = [
  'isOrder',
  'isStrategic',
  'isNewProduct',
  'isFeatured',
  'isSellin',
  'isPcapture',
  'isOutOfStock',
  'isUpdate',
] as const

export type Flag = (typeof FLAGS)[number]

export const FILTERED_FLAGS = FLAGS.filter((flag) => flag !== 'isUpdate')

export type FilteredFlag = (typeof FILTERED_FLAGS)[number]

export const FLAG_LABELS: Record<Flag, { fullLabel: string; badgeLabel: string }> = {
  isOrder: {
    fullLabel: 'Orderable',
    badgeLabel: 'ORD',
  },
  isStrategic: {
    fullLabel: 'Strategic',
    badgeLabel: 'STR',
  },
  isNewProduct: {
    fullLabel: 'New Product',
    badgeLabel: 'NEW',
  },
  isFeatured: {
    fullLabel: 'Featured',
    badgeLabel: 'FT',
  },
  isSellin: {
    fullLabel: 'Top Performer',
    badgeLabel: 'TOP',
  },
  isPcapture: {
    fullLabel: 'Price Capture',
    badgeLabel: 'PC',
  },
  isOutOfStock: {
    fullLabel: 'Out of Stock',
    badgeLabel: 'OOS',
  },
  isUpdate: {
    fullLabel: 'Updated',
    badgeLabel: 'Updated',
  },
} as const

export const FLAG_FILTER_OPTIONS: {
  value: Flag
  label: string
}[] = FLAGS.map((flag) => ({
  value: flag,
  label: FLAG_LABELS[flag].fullLabel,
}))

export const FILTERED_FLAG_FILTER_OPTIONS: {
  value: FilteredFlag
  label: string
}[] = FILTERED_FLAGS.map((flag) => ({
  value: flag,
  label: FLAG_LABELS[flag].fullLabel,
}))

export const FLAG_SELECTORS_OPTIONS = {
  TRUE: 'TRUE',
  FALSE: 'FALSE',
  UNDEFINED: 'UNDEFINED',
} as const

export const FLAG_OPTIONS = [
  {
    label: 'No Modification',
    value: FLAG_SELECTORS_OPTIONS.UNDEFINED,
  },
  {
    label: 'Enabled',
    value: FLAG_SELECTORS_OPTIONS.TRUE,
  },
  {
    label: 'Disabled',
    value: FLAG_SELECTORS_OPTIONS.FALSE,
  },
]
